import { SchemaService } from "@/shared/services/SchemaService";
import { AdvancedAnalysisSchema } from "../models/AdvancedAnalysisSchema";
import { AdvancedAnalysisService } from "./AdvancedAnalysisService";

export class AdvancedAnalysisSchemaService extends SchemaService<AdvancedAnalysisSchema> {

    static readonly injectableKey = 'AdvancedAnalysisSchemaService';

    get injectableKey() {
        return (this.constructor as typeof AdvancedAnalysisSchemaService).injectableKey;
    }

    public cdnContentPath: string = "advanced_analysis/advanced_analysis_schemas";

    public getInternalSchemas(): Array<AdvancedAnalysisSchema> {

        const internalAdvancedAnalysisSchemas = [
            {
                "type": `${AdvancedAnalysisService.CUSTOM_ADVANCED_ANALYSIS_TYPE}`,
                "display_name": "Unknown Advanced Analysis",
                "description": "Add unknown advanced analysis",
                "category": "Custom",
                "is_visible": true,
                "fields": [
                    {
                        "name": "value",
                        "display_name": "Json",
                        "field_type": "json",
                        "required": true,
                        "description": "Json Value"
                    }
                ],
                "examples": [
                    {
                        "type": "json"
                    }
                ]
            }
        ] as Array<AdvancedAnalysisSchema>;

        return internalAdvancedAnalysisSchemas;

    }

}